// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Loadable } from '@app/core';
import { State,  LoadingPolicyStatementResourceActionsAction, selectResourceActionsNeedLoading,
    selectStatementResources, selectLoadableResourceActions, selectStatementActions, selectStatementServices,
    LoadingPolicyStatementServicesAction, AddStatementAction, SelectEffectAction, SelectServiceAction,
    SelectResourceAction, SelectActionActions, ClearPolicyFormAction} from './index';


@Injectable({providedIn: 'root'})
export class PolicyStatementFacadeService {
    loadableServices$: Observable<any> = of();
    services$: Observable<any> = of();
    actions$: Observable<any> = of();
    resources$: Observable<any> = of();
    loadableResources$: Observable<any> = of();


    constructor(
        private store: Store<State>) {}

    loadServices () {
        this.loadableServices$ = this.store.pipe(select(selectStatementServices));

        this.loadableServices$.pipe(filter(data => !data)).subscribe(() =>
            this.store.dispatch(new LoadingPolicyStatementServicesAction()));

        this.services$ = this.loadableServices$.pipe(
          filter<Loadable>(loadable => loadable && loadable.data),
          map(loaded => loaded.data)
        );
    }

    loadResources (serviceId: string) {
        this.store.pipe(
            select(selectResourceActionsNeedLoading(serviceId)),
            filter(needLoading => needLoading)).subscribe(() =>
                this.store.dispatch(new LoadingPolicyStatementResourceActionsAction({ serviceId: serviceId })));

        this.resources$ = this.store.pipe(select(selectStatementResources(serviceId)));
        this.loadableResources$ = this.store.pipe(select(selectLoadableResourceActions(serviceId)));
    }

    getActions (serviceId: string, resourceId: string) {
        return this.store.pipe(select(selectStatementActions(serviceId, resourceId)));
    }

    setStatement ({ effect, service, resource, actions, statement_id }: any, statementIdx: number) {
        this.loadResources(service.id);

        this.store.dispatch(new AddStatementAction(statement_id));
        this.store.dispatch(new SelectEffectAction({ statementIdx, effect }));
        this.store.dispatch(new SelectServiceAction({ statementIdx, service }));
        this.store.dispatch(new SelectResourceAction({ statementIdx, resource }));
        this.store.dispatch(new SelectActionActions({ statementIdx, actions }));

      }

      clearPolicyForm () {
        this.store.dispatch(new ClearPolicyFormAction());
      }

      addNewStatement () {
        this.store.dispatch(new AddStatementAction());
      }

}




// WEBPACK FOOTER //
// ./src/app/access-management/state/policy-statement.facade.ts